import React from 'react';
import { FormattedDate, FormattedNumber } from 'react-intl';
import { Link } from 'react-router-dom';
import { WithSubRentals } from 'Utils/SvgIcons';
import { SubrentalsAllRowProps } from './SubrentalsAll.types';

const SubrentalsAllRow: React.FC<SubrentalsAllRowProps> = ({
  rentalInventory,
  link,
  location,
  multilocationAllLocations,
  onClick,
}) => {
  const { sub_rental, has_shortage, parent_rental } = rentalInventory;

  const startDate = rentalInventory?.rental_schedule?.offShelfAt;
  const endDate = rentalInventory?.rental_schedule?.onShelfAt;

  const orderLabel = [
    parent_rental?.token && `#${parent_rental.token}`,
    parent_rental?.name,
  ]
    .filter(Boolean)
    .join(' - ');

  return (
    <tbody>
      <Link className='rTableRow' to={link} onClick={onClick}>
        {multilocationAllLocations && (
          <td className='bold valignTop'>{location?.locationCode}</td>
        )}
        <td className='lg'>
          <p>
            <strong>{rentalInventory.name || 'Untitled'}</strong>
          </p>
          <p className='rentalRow__rentalToken'>{orderLabel}</p>
        </td>
        <td className='middle'>
          {startDate && (
            <FormattedDate
              value={new Date(startDate)}
              day='2-digit'
              month='2-digit'
            />
          )}
          {' - '}
          {endDate && (
            <FormattedDate
              value={new Date(endDate)}
              day='2-digit'
              month='2-digit'
              year='2-digit'
            />
          )}
        </td>
        <td className='middle no-wrap'>{sub_rental?.supplier}</td>
        <td className='middle'>{sub_rental?.customer_name}</td>
        <td className='middle'>{sub_rental?.contact}</td>
        <td className='middle'>
          {sub_rental?.expense && sub_rental.expense > 0 && (
            <FormattedNumber
              value={sub_rental.expense}
              style='currency'
              currency='USD'
            />
          )}
        </td>
        <td rowSpan={2} className='alert'>
          <WithSubRentals className={has_shortage ? 'orange' : 'green'} />
        </td>
      </Link>
    </tbody>
  );
};

export default SubrentalsAllRow;
